import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditAirport from "../../components/airports/Forms/FormAddEditAirport";

const EditAirport = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAirport isEdit={true} />
        </WrapperSection>
    );
};

export default EditAirport;
